var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app__buttons-group buttons-group",attrs:{"data-type":_vm.structure.type}},[_c('GameButton',{attrs:{"data":{
      content: _vm.$translate('questions')[_vm.structure.id].answers[0],
      type: _vm.structure.type,
      value: 0,
    }}}),(_vm.structure.type === 'boolean')?_c('div',{staticClass:"boolean__line"},[_c('img',{attrs:{"src":"/img/svg/line.svg"}})]):_vm._e(),_c('GameButton',{attrs:{"data":{
      content: _vm.$translate('questions')[_vm.structure.id].answers[1],
      type: _vm.structure.type,
      value: 1,
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }